"use client";

import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { forwardRef } from "react";
import { useDIYFilterOption } from "~/app/[lang]/(default)/overview/[type]/[id]/DIYListing/useDIYListing";
import { Link } from "~/components/Link";
import type { DIYAggregation } from "~/graphql/shared/page";

interface FilterItemProps {
	aggregation: DIYAggregation;
	option: DIYAggregation["options"][number];
}

export const FilterItem = forwardRef<HTMLAnchorElement, FilterItemProps>(function FilterItem(
	{ option, aggregation },
	ref,
) {
	const { href, isActive } = useDIYFilterOption({ aggregation, option });

	return (
		<Link ref={ref} href={href} className="group flex gap-2">
			<span
				className="mr-4 flex-grow group-hover:underline group-focus:underline"
				dangerouslySetInnerHTML={{ __html: option.label }}
			/>

			<span className="text-shades-medium text-sm">{option.count}</span>

			<div className="ml-4 flex h-6 w-6 items-start overflow-hidden rounded border border-shades">
				{isActive && (
					<div className="flex h-full w-full items-center justify-center bg-primary-medium">
						<FontAwesomeIcon size="sm" icon={faCheck} className="block h-5 w-5 text-white" />
					</div>
				)}
			</div>
		</Link>
	);
});
